import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFullPageLoading } from "../../../../atoms/full-page-loading/loadingContext";
import DialogModal from "../../../../atoms/dialog";
import { ClientAgendaApiData } from "./type";
import { getClientAgendas } from "./helper";
import { useSnackbar } from "notistack";
import AgendaTabs from "./agendaTabs";
import ExpertTab from "./expertTab";
import QuestionsTab from "./quesTab";
import SkeletonLoader from "../../../../atoms/project-details/SkeletonLoader";

type Props = {
    project_id: string;
    isOpen: boolean;
    handleClose(): void;
}

export default function PeClientAgendas({ isOpen, handleClose, project_id}: Props) {
    const [agendaData, setAgendaData] = useState<ClientAgendaApiData>({experts: [],agendas: []}); 
    const [agendaTab, setAgendaTab] = useState<"experts" | "questions">("experts");
    const { setLoading, isLoading } = useFullPageLoading();
    const { enqueueSnackbar } = useSnackbar();


    useEffect(() => {
        isOpen && getClientAgendas(setAgendaData,enqueueSnackbar,setLoading, project_id)
    },[isOpen])

    return (
        <DialogModal
            title={"Agenda Responses"}
            handleClose={handleClose}
            isOpen={isOpen}
            TitleEl={<AgendaTabs setAgendaTab={setAgendaTab} agendaTab={agendaTab}  />}
            titleHeadSx={{
                "& p": {
                    fontSize: '14px',
                    textWrap: "nowrap",
                    mr: "20px"
                },
                flexWrap: {
                    xs: "wrap",
                    sm: "nowrap"
                }
            }}
        >
            {!isLoading ?  
                <Grid container>
                    <>{
                            agendaTab === "experts" ? 
                                <ExpertTab expertData={agendaData.experts} /> 
                                : <QuestionsTab agendaData={agendaData.agendas} /> 
                        }</>
                </Grid> 
                : <>
                <SkeletonLoader height={"500px"} style={{marginTop: "20px"}} />
                </>}
        </DialogModal>
    )
}


export function NoAgenda() {
    return (
        <p style={{
            color: "#252B3B",
            fontSize: "14px",
            }}>
                No Agenda Found for this Project
        </p>
    )
}